module.exports = `${require.publicPath}southbay.f88bab48.webp`;